module.exports = __webpack_public_path__ + "static/media/3.0f9b452c.png";